import Image from 'next/image';
import Link from 'next/link';


const MooikindWelcome = () => {

  return (
    <div>
      <Link href="https://www.mooimom.id/product-category/brand/?brand=mooikind">
        <div className="md:hidden">
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/mooikind/mb-1.png"}
            alt="main banner"
            quality={100}
            width={1080}
            height={1404}
            className="w-full"
          />
        </div>
        <div className="hidden md:block">
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/mooikind/pc-1.png"}
            alt="main banner"
            quality={100}
            width={1920}
            height={1818}
            className="w-full"
          />
        </div>
      </Link>
      <div className="-mt-[100px] md:-mt-[470px]">
        <Link href="https://www.mooimom.id/product/mooikind-fun-de-plat-set/">
          <div className="md:hidden">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/mooikind/mb-2.png"}
              alt="meal set banner"
              quality={100}
              width={1080}
              height={2213}
              className="w-full"
            />
          </div>
          <div className="hidden md:block">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/mooikind/pc-2.png"}
              alt="meal set banner"
              quality={100}
              width={1920}
              height={2344}
              className="w-full"
            />
          </div>
        </Link>
      </div>
      <div className="-mt-[60px] md:-mt-[190px]">
        <Link href="https://www.mooimom.id/product/mooikind-fun-de-jar/">
          <div className="md:hidden">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/mooikind/mb-3.png"}
              alt="fun jar banner"
              quality={100}
              width={1078}
              height={1969}
              className="w-full"
            />
          </div>
          <div className="hidden md:block">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/mooikind/pc-3.png"}
              alt="fun jar banner"
              quality={100}
              width={1920}
              height={1352}
              className="w-full"
            />
          </div>
        </Link>
      </div>
      <div className="-mt-[60px] md:-mt-[190px]">
        <Link href="https://www.mooimom.id/product/mooikind-kinder-de-bottle/">
          <div className="md:hidden">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/mooikind/mb-4.png"}
              alt="tritan bottle banner"
              quality={100}
              width={1078}
              height={1817}
              className="w-full"
            />
          </div>
          <div className="hidden md:block">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/mooikind/pc-4.png"}
              alt="tritan bottle banner"
              quality={100}
              width={1920}
              height={1352}
              className="w-full"
            />
          </div>
        </Link>
      </div>
      <div className="-mt-[60px] md:-mt-[190px]">
        <Link href="https://www.mooimom.id/product/mooikind-fun-de-cup/">
          <div className="md:hidden">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/mooikind/mb-5.png"}
              alt="drink cup banner"
              quality={100}
              width={1078}
              height={1969}
              className="w-full"
            />
          </div>
          <div className="hidden md:block">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/mooikind/pc-5.png"}
              alt="drink cup banner"
              quality={100}
              width={1920}
              height={1352}
              className="w-full"
            />
          </div>
        </Link>
      </div>
      <div className="-mt-[100px] md:-mt-[190px]">
        <Link href="https://www.mooimom.id/product/mooikind-lunch-box/">
          <div className="md:hidden">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/mooikind/mb-6.png"}
              alt="bento box banner"
              quality={100}
              width={1078}
              height={1817}
              className="w-full"
            />
          </div>
          <div className="hidden md:block">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/mooikind/pc-6.png"}
              alt="bento box banner"
              quality={100}
              width={1920}
              height={2344}
              className="w-full"
            />
          </div>
        </Link>
      </div>
      <div className="-mt-[60px] md:-mt-[190px]">
        <Link href="https://www.mooimom.id/product-category/brand/?brand=mooikind">
          <div className="md:hidden">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/mooikind/mb-7.png"}
              alt="bento box banner"
              quality={100}
              width={1078}
              height={2009}
              className="w-full"
            />
          </div>
          <div className="hidden md:block">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/mooikind/pc-7.png"}
              alt="bento box banner"
              quality={100}
              width={1920}
              height={1352}
              className="w-full"
            />
          </div>
        </Link>
      </div>
      <div className="-mt-[60px] md:-mt-[190px]">
        <Link href="https://www.mooimom.id/product/mooimom-x-mooikind-baby-wet-wipes-with-edi-water-80-sheets/">
          <div className="md:hidden">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/mooikind/mb-8.png"}
              alt="wet wipes banner"
              quality={100}
              width={1078}
              height={1410}
              className="w-full"
            />
          </div>
          <div className="hidden md:block">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/mooikind/pc-8.png"}
              alt="wet wipes banner"
              quality={100}
              width={1920}
              height={1199}
              className="w-full"
            />
          </div>
        </Link>
      </div>
      <div className="relative -mt-1 md:hidden">
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/mooikind/mb-9.png"}
          alt="mooikind"
          quality={100}
          width={1080}
          height={1015}
          className="w-full"
        />
        <div className="absolute flex justify-center w-full bottom-4">
          <div className="grid w-3/4 grid-cols-2 gap-4">
            <div className="">
              <Link href="https://www.tiktok.com/@mooikind.id">
                <Image
                  src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/mooikind/pc-10.png"}
                  alt="tiktok"
                  quality={100}
                  width={403}
                  height={99}
                  className="w-[400px] h-auto cursor-pointer"
                />
              </Link>
            </div>
            <div className="">
              <Link href="https://shopee.co.id/mooikind.id">
                <Image
                  src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/mooikind/pc-11.png"}
                  alt="shopee"
                  quality={100}
                  width={403}
                  height={99}
                  className="w-[400px] h-auto cursor-pointer"
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="relative hidden md:block -mt-[50px]">
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/mooikind/pc-9.png"}
          alt="mooikind"
          quality={100}
          width={1920}
          height={912}
          className="w-full"
        />
        <div className="absolute grid w-full grid-cols-2 top-1/2 -translate-y-1/1">
          <div></div>
          <div className="-mt-10">
            <div className="flex justify-center mb-8">
              <Link href="https://www.tiktok.com/@mooikind.id">
                <Image
                  src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/mooikind/pc-10.png"}
                  alt="tiktok"
                  quality={100}
                  width={403}
                  height={99}
                  className="w-[400px] h-auto cursor-pointer"
                />
              </Link>
            </div>
            <div className="flex justify-center">
              <Link href="https://shopee.co.id/mooikind.id">
                <Image
                  src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/mooikind/pc-11.png"}
                  alt="shopee"
                  quality={100}
                  width={403}
                  height={99}
                  className="w-[400px] h-auto cursor-pointer"
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MooikindWelcome
